export const stage = 'https://91wfxb0g38.execute-api.ca-central-1.amazonaws.com/Nova'; //DEVELOPMENT
/* export const stage = 'https://bsy88ru8bj.execute-api.ca-central-1.amazonaws.com/IFM_PRODUCTION'; //PRODUCTION */
